import { render, staticRenderFns } from "./ModalEditarTituloEnquete.vue?vue&type=template&id=4fb670ac&scoped=true"
import script from "./ModalEditarTituloEnquete.vue?vue&type=script&lang=js"
export * from "./ModalEditarTituloEnquete.vue?vue&type=script&lang=js"
import style0 from "./ModalEditarTituloEnquete.vue?vue&type=style&index=0&id=4fb670ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb670ac",
  null
  
)

export default component.exports